import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header-bar">
      <div className="logo">
        <span className="logo-icon">👨‍💼</span> Employee Leave Prediction
      </div>
      <nav className="nav-links">
        <a href="EmployeeLeaveTable.js">Table</a>
        <a href="#about">About</a>
        <a href="#contact">Contact</a>
      </nav>
    </header>
  );
};

export default Header;
